import { Box, Text } from '@radix-ui/themes'
import { IconX } from '@tabler/icons-react'
import clsx from 'clsx'
import { hoverActiveEffect } from '@/utils/style'
import Hstack from '../ui/hstack'
import {
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerHeader,
  DrawerOverlay,
  DrawerTitle,
} from './drawer'

type DrawerProps = React.ComponentProps<typeof Drawer> & {
  children: React.ReactNode
  title: string
  className?: string
}
export default function SectionDrawer({
  children,
  title,
  className,
  ...props
}: DrawerProps) {
  return (
    <Drawer
      direction='right'
      dismissible={false}
      autoFocus
      repositionInputs
      {...props}
    >
      <DrawerOverlay className='bg-[#000000B2]' />
      <DrawerContent
        className={clsx(
          'flex h-full max-h-screen min-h-0 !max-w-full flex-col gap-[16px] bg-[#F6F7F9]',
          className
        )}
      >
        <DrawerHeader>
          <DrawerTitle className='hidden' />
          <DrawerDescription className='hidden' />
          <Hstack justify={'between'} align={'center'} className='leading-0'>
            <Text className='text-[24px] font-normal text-[#002652]'>
              {title}
            </Text>
            <IconX
              color='#98A2B3'
              size={'24px'}
              className={clsx(hoverActiveEffect)}
              onClick={props.onClose}
            />
          </Hstack>
        </DrawerHeader>
        <Box className='flex min-h-0 flex-1 flex-col px-[24px]'>{children}</Box>
      </DrawerContent>
    </Drawer>
  )
}
